/**
 * Utilidad para combinar clases de Tailwind
 *
 * Combina clsx (para condicionales) con tailwind-merge
 * (para resolver conflictos de clases)
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combina clases CSS de forma inteligente
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-blue-500', className)
 * cn('text-red-500', 'text-blue-500') // → 'text-blue-500' (resuelve conflicto)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
